import { render, staticRenderFns } from "./RecentCalls.vue?vue&type=template&id=b844b62e&scoped=true"
import script from "./RecentCalls.vue?vue&type=script&lang=js"
export * from "./RecentCalls.vue?vue&type=script&lang=js"
import style0 from "./RecentCalls.vue?vue&type=style&index=0&id=b844b62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b844b62e",
  null
  
)

export default component.exports